import { render } from "./Recipients.vue?vue&type=template&id=93818c3a&scoped=true"
import script from "./Recipients.vue?vue&type=script&lang=js"
export * from "./Recipients.vue?vue&type=script&lang=js"

import "./Recipients.vue?vue&type=style&index=0&id=93818c3a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93818c3a"]])

export default __exports__